import React, { useState, useEffect } from 'react'
import { Title, DataTable, Spinner, DateFormat, HttpService, API } from '../../config/react'
const QrStatistics = () => {
  const [loading, setLoading] = useState(false)
  const [IsAuth, setIsAuth] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [SearchTerm, setSearchTerm] = useState('')
  const [totalRows, settotalRows] = useState(0)
  const [AppointmentQRList, setAppointmentQRList] = useState([])
  const [stats, setStats] = useState({
    page_visit: 0,
    form_submitted: 0,
    conversion_rate: 0
  })
  const DefaultFilters = {
    page: 1,
    // search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)

  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }
  const handleSort = (e, direction) => {
    // console.log('LN 127 Sort FIeld ' + e.sortField)
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }
  useEffect(() => {
    setIsAuth(true)
    document.title = Title.AppointmentQRStatistics
    GetAppointmentQRList()
  }, [CustomFilters, SearchTerm])

  const GetAppointmentQRList = () => {
    const params = {
      page: CustomFilters.page,
      search: SearchTerm,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    setLoading(true)
    HttpService.postApi(API.GetAppointmentQRStatisticsList, params).then((response) => {
      setLoading(false)
      if (response.data.status === true && response.data.result !== '') {
        const data = response.data.result
        console.log('LN 143 GetAppointmentQRList ', data)
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total)
        setStats({
          page_visit: response.data.result[2][0].total_visits,
          form_submitted: response.data.result[2][0].submitted,
          conversion_rate: response.data.result[2][0].conversion_rate
        })
        setAppointmentQRList(response.data.result[1])
      } else {
        settotalRows(0)
        setAppointmentQRList([])
      }
    })
  }

  const columns = [
    // {
    //   name: 'ID',
    //   selector: (row) => row.id,
    //   sortable: true,
    //   sortField: 'id'
    // },
    {
      name: 'IP Address',
      selector: (row) => row.ip_address?.replace('::ffff:', '') || '-',
      sortable: true,
      sortField: 'ip_address'
    },
    {
      name: 'Source',
      selector: (row) => row.source || '-',
      sortable: true,
      sortField: 'source'
    },
    {
      name: 'Campaign',
      selector: (row) => row.campaign || '-',
      sortable: true,
      sortField: 'campaign'
    },

    {
      name: 'Country',
      selector: (row) => row.country || '-',
      sortable: true,
      sortField: 'country'
    },
    {
      name: 'User Device',
      selector: (row) => {
        if (!row.user_agent) return '-'

        if (/mobile/i.test(row.user_agent)) return 'Mobile'
        if (/tablet|ipad/i.test(row.user_agent)) return 'Tablet'
        return 'Desktop'
      }
    },
    {
      name: 'Form Submitted',
      selector: (row) =>
        row.is_submitted === 1 ? (
          <span className="badge bg-primary">Yes</span>
        ) : (
          <span className="badge bg-primary">No</span>
        ),
      sortable: true,
      sortField: 'is_submitted'
    },
    {
      name: 'Created At',
      selector: (row) => <DateFormat value={row.created_at} />,
      sortable: true,
      sortField: 'created_at'
    }
  ]

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Title"
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.AppointmentQRStatistics} </h3>
      </div>
      <div className="row">
        <div className="col-md-6 col-lg-4 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="w-100">
                <div className="card-header p-0 mb-3">
                  <h3 className="title font-20">Page Visit</h3>
                </div>
                <table className="table table-striped table-borderless">
                  <tbody>
                    <tr>
                      <td className="w-75">{stats.page_visit}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="w-100">
                <div className="card-header p-0 mb-3">
                  <h3 className="title font-20">Form Submitted</h3>
                </div>
                <table className="table table-striped table-borderless">
                  <tbody>
                    <tr>
                      <td className="w-75">{stats.form_submitted}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="w-100">
                <div className="card-header p-0 mb-3">
                  <h3 className="title font-20">Conversion Rate</h3>
                </div>
                <table className="table table-striped table-borderless">
                  <tbody>
                    <tr>
                      <td className="w-75">{stats.conversion_rate}%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={AppointmentQRList}
                  pagination
                  persistTableHead={true}
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  onSort={handleSort}
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  paginationDefaultPage={currentPage}
                  subHeaderComponent={subHeaderComponentMemo}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default QrStatistics
